const featuredCasesRouter = {
  route: null,
  name: null,
  title: '精品案例',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont el-icon-suitcase-1',
  filePath: 'view/featured_cases/', // 文件路径
  order: 25,
  inNav: true,
  permission: ['精选案例列表'],
  children: [
    {
      title: '精选案例列表',
      type: 'view',
      name: 'featuredCasesList',
      route: '/featuredCases/list',
      filePath: 'view/featured_cases/list.vue',
      inNav: true,
      icon: 'iconfont el-icon-notebook-2',
      permission: ['精选案例列表'],
    },
    {
      title: '新增精选案例',
      type: 'view',
      name: 'addFeaturedCases',
      route: '/featuredCases/add',
      filePath: 'view/featured_cases/create.vue',
      inNav: true,
      icon: 'iconfont el-icon-document-add',
      permission: ['新增精选案例'],
    },
  ],
}

export default featuredCasesRouter
